import DOMPurify from "dompurify";

export default function sanitize(html, config = {}) {
    const defaultConfig = {
        USE_PROFILES: { html: true },
    };

    if (config) {
        Object.keys(config).forEach((key) => {
            defaultConfig[key] = config[key];
        });
    }

  return DOMPurify.sanitize(html, defaultConfig);
}